import _get from 'lodash/get'
import { COUNTRY } from '../../../../utils/constants'
import { loadValue } from '../../../../utils/localStorage'
import { selectCalculationState } from '../../../../utils/selectors'
import { createGenericSlice } from '../../../../utils/slices'
import {
  ANCHORAGE_OPTION,
  APP_STATE_KEY,
  COMPRESSIVE_STRENGTH,
  CORROSION_RESISTANCE_VALUE,
  DESIGN_CODE,
  DOWNLOAD_DURATION,
  FOUNDATION_TYPE,
  HOLDOWN_FASTENERS,
  HOLDOWN_SUBTYPE,
  HOLDOWN_TYPE,
  INSTALLATION_TYPE,
  LUMBER_SPECIES,
  MATERIAL_TYPE,
  MIN_STEMWALL_THICKNESS_INITIAL_STATE,
  POST_BASE_FASTENERS_TYPE,
  POST_BASE_GEOMETRY_SUBTYPE,
  POST_BASE_GEOMETRY_TYPE,
  POST_BASE_LOAD_TYPE,
  POST_BASE_LUMBER_SPECIES,
  POST_BASE_MATERIAL_TYPE,
  POST_BASE_SUBTYPE,
  POST_BASE_TYPE,
  POST_THICKNESS_INITIAL_STATE,
  POST_WIDTH_INITIAL_STATE,
  SETTINGS_INITIAL_STATE,
  UPLIFT_DURATION,
  WALL_THICKNESS
} from '../../common/constants'
import { fieldSwitchSubAppAction } from '../actions/calculation.action'

export const getInitialState = () => {
  const persistedState = loadValue(APP_STATE_KEY)
  const country = _get(persistedState, 'calculation.settings.country', COUNTRY.USA)

  return {
    holdownDesign: true,
    foundationDesign: false,
    postBaseDesign: false,
    upliftLoadASD: '0',
    downloadASD: '0',
    lateralF1: '0',
    lateralF2: '0',
    loadType: '0',
    designCode: DESIGN_CODE.IBC2018,
    holdownSubType: HOLDOWN_SUBTYPE.EMBEDDED_ANCHOR,
    postBaseSubType: POST_BASE_SUBTYPE.POST_INSTALLED,
    lumberSpecies:
      country === COUNTRY.USA
        ? LUMBER_SPECIES.DOUGLAS_FIR_LARCH
        : POST_BASE_LUMBER_SPECIES[COUNTRY.CANADA].DOUGLAS_FIR_LARCH,
    postBaseLumberSpecies: POST_BASE_LUMBER_SPECIES[country].DOUGLAS_FIR_LARCH,
    wallThickness: WALL_THICKNESS.INCH4,
    holdownFastenersType: [HOLDOWN_FASTENERS.ALL],
    postBaseFastenersType: [POST_BASE_FASTENERS_TYPE.ALL],
    installOverSheathing: 'false',
    compressiveStrength: COMPRESSIVE_STRENGTH.PSI2500,
    anchorageOption: ANCHORAGE_OPTION.CAST_IN_PLACE,
    geometryType: '2',
    postBaseGeometryType: POST_BASE_GEOMETRY_TYPE.STEMWALL,
    geometrySubType: '1',
    postBaseGeometrySubType: POST_BASE_GEOMETRY_SUBTYPE.MID_WALL_ANCHOR,
    materialType: MATERIAL_TYPE.CONCRETE,
    postBaseMaterialType: POST_BASE_MATERIAL_TYPE.CONCRETE,
    twoPourInstall: 'false',
    raisedFloor: 'false',
    postBaseLoadType: POST_BASE_LOAD_TYPE.WIND_AND_SDC_AB,
    validation: {},
    corrosionResistance: [CORROSION_RESISTANCE_VALUE.ALL],
    settings: SETTINGS_INITIAL_STATE,
    holdownType: HOLDOWN_TYPE.POST_INSTALLED,
    postBaseType: POST_BASE_TYPE.POST_INSTALLED,
    foundationType: FOUNDATION_TYPE.CONCRETE_2500,
    upliftDuration: UPLIFT_DURATION.SHORT,
    factoredUpliftLRFD: '0',
    factoredDownloadLRFD: '0',
    minStemwallThickness: MIN_STEMWALL_THICKNESS_INITIAL_STATE,
    downloadDuration: DOWNLOAD_DURATION.STANDARD,
    postWidth: POST_WIDTH_INITIAL_STATE,
    postThickness: POST_THICKNESS_INITIAL_STATE,
    installationType: INSTALLATION_TYPE.MID_WALL,
  }
}

export const inputSlice = createGenericSlice({
  name: 'input',
  initialState: getInitialState(),
  reducers: {
    setFieldError: (state, action) => {
      const { name, message } = action.payload
      state.validation[name] = message
    },
    removeFieldError: (state, action) => {
      const name = action.payload
      delete state.validation[name]
    },
  },
  extraReducers: (builder) =>
    builder.addCase(fieldSwitchSubAppAction, (state, action) => {
      Object.assign(state, action.payload)
    }),
})

export const inputActions = inputSlice.actions

export const selectInputState = (state) => selectCalculationState(state)[inputSlice.name]
